import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

export function configureDayjs() {
    dayjs.extend(utc);
    dayjs.extend(timezone);
}
